import { render, staticRenderFns } from "./GerenciamentoServicoListFiltroModalItem.vue?vue&type=template&id=037dfaca"
import script from "./GerenciamentoServicoListFiltroModalItem.vue?vue&type=script&lang=js"
export * from "./GerenciamentoServicoListFiltroModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports